import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const items = [{
  left: 'Meses de desgaste que nadie compensa',
  right: 'Tu energía y bienestar que no vuelven'
}, {
  left: 'Ansiedad sin herramientas reales',
  right: 'Calidad de vida que se erosiona día a día'
}, {
  left: 'Discusiones sueltas que no resuelven nada',
  right: 'Tiempo emocional gastado sin sistema'
}, {
  left: 'Improvisar respuestas en el momento',
  right: 'Más arrepentimiento y más agotamiento'
}, {
  left: 'Manipulación que no detectás a tiempo',
  right: 'Desgaste emocional acumulado mes tras mes'
}, {
  left: 'Conflictos en pareja sin comunicación',
  right: 'Distancia que crece sin poder nombrarse'
}, {
  left: 'El mismo ciclo de postergación',
  right: 'El próximo año exactamente igual que este'
}];
export function CostSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-61">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-62">
            ⚖️ ¿Cuánto cuesta{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-63">
              no tenerlo
            </span>
            ?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl overflow-hidden shadow-sm" data-id="element-64">
          <div className="grid grid-cols-2 bg-bg-warm border-b border-line" data-id="element-65">
            <div className="p-4 md:p-5 text-center font-bold text-ink text-sm md:text-base border-r border-line" data-id="element-66">
              Sin el ebook
            </div>
            <div className="p-4 md:p-5 text-center font-bold text-rose text-sm md:text-base" data-id="element-67">
              Costo real
            </div>
          </div>
          {items.map((it, i) => <div key={i} className={`grid grid-cols-2 ${i !== items.length - 1 ? 'border-b border-line' : ''}`} data-id="element-68">
              <div className="p-4 md:p-5 flex items-start gap-2.5 border-r border-line" data-id="element-69">
                <XIcon className="w-4 h-4 text-rose flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-70" />
                <span className="text-sm md:text-base text-ink" data-id="element-71">{it.left}</span>
              </div>
              <div className="p-4 md:p-5 text-sm md:text-base text-ink-soft italic" data-id="element-72">
                {it.right}
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mt-10" data-id="element-73">
          <p className="font-serif-italic text-ink text-xl md:text-2xl mb-2" data-id="element-74">
            El próximo paso en tu camino puede empezar hoy.
          </p>
          <p className="font-serif-italic text-rose text-lg md:text-xl" data-id="element-75">
            "Tu paz mental merece protección." 🌸
          </p>
        </motion.div>
      </div>
    </section>;
}